import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppContext } from '@/common/hooks/AppStateProvider';
import Page404 from '@/common/views/Page404';

const PlatformAdminGuard = () => {
  const location = useLocation();
  const { session } = useAppContext();

  if (session.status !== 'authenticated') {
    return <Navigate to="/" state={{ from: location.pathname }} replace />;
  }

  if (!session.user?.isPlatformAdmin) {
    return <Page404 />;
  }

  return <Outlet />;
};

export default PlatformAdminGuard;
